
import btn from '../components/btn'
import { copyToClip } from '@/utils/index'
export default {
    name: 'ChangeBindAccount',
    components: {
        btn
    },
    props: {
        content: {
            type: Object,
            default: () => ({})
        },
        mentionedUser: {
            type: String,
            default: ''
        },
        canSeeBtns: {
            type: Boolean,
            default: false
        },
        displayData: {
            type: Object,
            default: () => ({})
        },
        isSeller: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
        }
    },
    methods: {
        copyToClip
    }
}
